import { render, staticRenderFns } from "./LocalItem.vue?vue&type=template&id=0d36c6e8"
import script from "./LocalItem.vue?vue&type=script&lang=js"
export * from "./LocalItem.vue?vue&type=script&lang=js"
import style0 from "./LocalItem.vue?vue&type=style&index=0&id=0d36c6e8&prod&lange=less&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports